export const RememberMeTypes = {
    SET_REMEMBER_ME: 'SET_REMEMBER_ME',
    SET_REMEMBER_ME_MAIL: 'SET_REMEMBER_ME_MAIL',
    SET_REMEMBER_ME_PASSWORD: 'SET_REMEMBER_ME_PASSWORD',

};
